import React from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import styled from "styled-components";

import DrawingExample from "./drawing-example.tsx";

// Styled Components
const MapCanvas = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  position: relative;
  width: 100vw;
`;

const TestMap2 = () => {
  return (
    <MapCanvas>
      <APIProvider apiKey={"AIzaSyBy0cowEjTB0suohBM4h4UdiSz-ng-YPWg"}>
        <DrawingExample />
      </APIProvider>
    </MapCanvas>
  );
};

export default TestMap2;
